import * as XLSX from 'xlsx';
import { Order, OrderItem } from '../types';

export const exportOrderToExcel = (order: Order, orderItems: OrderItem[]) => {
  const wb = XLSX.utils.book_new();

  const formatCurrency = (value: number) => {
    return `R$ ${value.toFixed(2).replace('.', ',')}`;
  };

  const formatDate = (dateString?: string) => {
    if (!dateString) return '';
    const [year, month, day] = dateString.split('-').map(Number);
    const date = new Date(year, month - 1, day);
    return date.toLocaleDateString('pt-BR');
  };

  const orderData = [
    ['DETALHES DO PEDIDO'],
    [],
    ['Número do Pedido:', order.orderNumber],
    ['Nome da Loja:', order.storeName],
    ['Valor Total:', formatCurrency(order.totalValue)],
    ['Forma de Pagamento:', order.paymentMethod],
    ['Data da Compra:', formatDate(order.purchasedAt)],
    ['Status:', getStatusLabel(order.status)],
    [],
    ['DATAS DO PEDIDO'],
    [],
    ['Pagamento Aprovado:', formatDate(order.paymentApprovedAt)],
    ['Faturado:', formatDate(order.invoicedAt)],
    ['Entregue:', formatDate(order.deliveredAt)],
    [],
    [],
    ['ITENS DO PEDIDO'],
    [],
    ['SKU', 'Produto', 'Quantidade', 'Qtd. Faturada', 'Valor Unitário', 'Valor Total', 'Total Faturado'],
  ];

  orderItems.forEach(item => {
    orderData.push([
      item.sku,
      item.productName,
      item.quantity.toString(),
      item.invoicedQuantity.toString(),
      formatCurrency(item.unitPrice),
      formatCurrency(item.totalPrice),
      formatCurrency(item.invoicedTotal),
    ]);
  });

  orderData.push([]);
  orderData.push(['', '', '', '', '', 'SUBTOTAL:', formatCurrency(order.totalValue)]);

  const ws = XLSX.utils.aoa_to_sheet(orderData);

  ws['!cols'] = [
    { wch: 20 },
    { wch: 40 },
    { wch: 12 },
    { wch: 15 },
    { wch: 15 },
    { wch: 15 },
    { wch: 15 },
  ];

  const headerStyle = {
    font: { bold: true, sz: 14, color: { rgb: "FFFFFF" } },
    fill: { fgColor: { rgb: "0F172A" } },
    alignment: { horizontal: "center", vertical: "center" },
  };

  const subHeaderStyle = {
    font: { bold: true, sz: 12, color: { rgb: "FFFFFF" } },
    fill: { fgColor: { rgb: "475569" } },
    alignment: { horizontal: "center", vertical: "center" },
  };

  const tableHeaderStyle = {
    font: { bold: true, sz: 11, color: { rgb: "334155" } },
    fill: { fgColor: { rgb: "F1F5F9" } },
    alignment: { horizontal: "center", vertical: "center" },
    border: {
      top: { style: "thin", color: { rgb: "CBD5E1" } },
      bottom: { style: "thin", color: { rgb: "CBD5E1" } },
      left: { style: "thin", color: { rgb: "CBD5E1" } },
      right: { style: "thin", color: { rgb: "CBD5E1" } },
    },
  };

  const cellStyle = {
    alignment: { vertical: "center" },
    border: {
      top: { style: "thin", color: { rgb: "E2E8F0" } },
      bottom: { style: "thin", color: { rgb: "E2E8F0" } },
      left: { style: "thin", color: { rgb: "E2E8F0" } },
      right: { style: "thin", color: { rgb: "E2E8F0" } },
    },
  };

  const totalStyle = {
    font: { bold: true, sz: 12 },
    alignment: { horizontal: "right", vertical: "center" },
  };

  if (ws['A1']) ws['A1'].s = headerStyle;
  if (ws['A10']) ws['A10'].s = subHeaderStyle;
  if (ws['A17']) ws['A17'].s = subHeaderStyle;

  const tableHeaderRow = 19;
  for (let col = 0; col < 7; col++) {
    const cellRef = XLSX.utils.encode_cell({ r: tableHeaderRow - 1, c: col });
    if (ws[cellRef]) ws[cellRef].s = tableHeaderStyle;
  }

  for (let row = tableHeaderRow; row < tableHeaderRow + orderItems.length; row++) {
    for (let col = 0; col < 7; col++) {
      const cellRef = XLSX.utils.encode_cell({ r: row, c: col });
      if (ws[cellRef]) ws[cellRef].s = cellStyle;
    }
  }

  const totalRow = tableHeaderRow + orderItems.length + 1;
  const totalCellF = XLSX.utils.encode_cell({ r: totalRow, c: 5 });
  const totalCellG = XLSX.utils.encode_cell({ r: totalRow, c: 6 });
  if (ws[totalCellF]) ws[totalCellF].s = totalStyle;
  if (ws[totalCellG]) ws[totalCellG].s = totalStyle;

  ws['!merges'] = [
    { s: { r: 0, c: 0 }, e: { r: 0, c: 6 } },
    { s: { r: 9, c: 0 }, e: { r: 9, c: 6 } },
    { s: { r: 16, c: 0 }, e: { r: 16, c: 6 } },
  ];

  XLSX.utils.book_append_sheet(wb, ws, 'Pedido');

  XLSX.writeFile(wb, `Pedido_${order.orderNumber}.xlsx`);
};

const getStatusLabel = (status: string): string => {
  const statusMap: Record<string, string> = {
    pedido_realizado: 'Pedido realizado',
    pagamento_aprovado: 'Pagamento aprovado',
    faturamento_realizado: 'Faturamento realizado',
    separacao_transporte: 'Separação/ transporte',
    entrega: 'Entrega',
    cancelado: 'Cancelado'
  };
  return statusMap[status] || status;
};
